import { useContext, useState } from 'react';

import { AppContext } from '../../../bootstrap/App';
import { UserTheme, UserThemeList } from '../../../features/users/enums/UserTheme';
import CustomUserData from '../../../features/users/models/CustomUserData';
import Select from '../Select/Select';

interface Props {
  setData: (data: Partial<CustomUserData>) => void;
}

function WelcomeWizardTheme(props: Props) {
  const { setData } = props;

  const [value, setValue] = useState(UserTheme.Light);

  const { setDarkMode } = useContext(AppContext);

  const handleChange = async (newValue: UserTheme) => {
    setValue(newValue);

    await setData({ theme: newValue });
    setDarkMode(newValue === UserTheme.Dark);
  };

  return (
    <Select
      id='theme'
      label='Theme'
      items={UserThemeList}
      value={value}
      onChange={(event) => handleChange(event.target.value as UserTheme)}
      required={true}
    />
  );
}

export default WelcomeWizardTheme;
